import React, { useEffect, useState } from 'react';
import { Modal, Upload, Button, Checkbox, message, Row, Col } from 'antd';
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import { GetAllPages } from '../../dao/GetAllPages';
import { PostImportUsers } from '../../dao/PostImportUsers';
import * as XLSX from 'xlsx';

interface Props {
    visible: boolean;
    onClose: () => void;
    aulaId: string;
}

const AulaImportModal: React.FC<Props> = ({ visible, onClose, aulaId }) => {
    const [pages, setPages] = useState<any[]>([]);
    const [selectedPages, setSelectedPages] = useState<number[]>([]);
    const [fileList, setFileList] = useState<any[]>([]);
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        if (visible) {
            loadPages();
        }
    }, [visible]);

    const loadPages = async () => {
        const data = await GetAllPages();
        setPages(data);
        const defaultIds = data.filter((p: any) => p.titol === 'Home' || p.titol === 'Sortir').map((p: any) => p.id);
        setSelectedPages(defaultIds);
    };

    const handleDownloadTemplate = () => {
        // Create a worksheet
        const ws = XLSX.utils.aoa_to_sheet([
            ["usu", "pass", "nom", "cognoms", "rol (2)", "estat (1)", "curs (1SMX)", "estat", "grup (grau-mitja)"],
            ["user1", "1234", "Nom", "Cognom", "2", "1", "1SMX", "1", "grau-mitja"]
        ]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Template");
        XLSX.writeFile(wb, "import_users_template.xlsx");
    };

    const handleUpload = async () => {
        if (fileList.length === 0) {
            message.warning("Selecciona un archivo primero");
            return;
        }
        setUploading(true);
        const formData = new FormData();
        formData.append("file", fileList[0]);
        // Format to string "1,2,3" is common, but let's check Backend. 
        // Backend: List<Integer> pages. Spring handles multiple param values: `pages=1&pages=2...` or comma-separated.
        // FormData append with same key usually sends multiple parts, or if key implies array?
        // Let's send comma separated string since Spring usually parses it.
        formData.append("pages", selectedPages.join(","));

        const success = await PostImportUsers(aulaId, formData);
        setUploading(false);
        if (success) {
            setFileList([]);
            setSelectedPages([]);
            onClose();
        } else {
            message.error("Error en la importación");
        }
    };

    return (
        <Modal title="Importar Usuarios Excel" open={visible} onCancel={onClose} footer={[
            <Button key="cancel" onClick={onClose}>Cancelar</Button>,
            <Button key="submit" type="primary" loading={uploading} onClick={handleUpload}>Importar</Button>
        ]}>
            <div style={{ marginBottom: 20 }}>
                <Button icon={<DownloadOutlined />} onClick={handleDownloadTemplate}>Descargar Plantilla</Button>
            </div>

            <div style={{ marginBottom: 20 }}>
                <h4>Selecciona páginas para asignar permisos:</h4>
                <Checkbox.Group style={{ width: '100%' }} value={selectedPages} onChange={(checkedValues) => setSelectedPages(checkedValues as number[])}>
                    <Row>
                        {pages.map(p => (
                            <Col span={12} key={p.id}>
                                <Checkbox value={p.id} disabled={p.titol === 'Home' || p.titol === 'Sortir'}>{p.titol}</Checkbox>
                            </Col>
                        ))}
                    </Row>
                </Checkbox.Group>
            </div>

            <Upload
                beforeUpload={(file) => { setFileList([file]); return false; }}
                fileList={fileList}
                onRemove={() => setFileList([])}
                maxCount={1}
            >
                <Button icon={<UploadOutlined />}>Seleccionar Excel</Button>
            </Upload>

            <div style={{ marginTop: 10, fontSize: 12, color: 'gray' }}>
                * El Excel debe contener las columnas: usu, pass, nom, cognoms, rol, estat, curs, estat, grup.
            </div>
        </Modal>
    );
};
export default AulaImportModal;
